(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/play/assets/javascripts/coupon/race-track-info.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/play/assets/javascripts/coupon/race-track-info.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  useState,
  useContext
} = React;
const {
  RacePickerItemLight
} = svs.racing;
const {
  ImageTypes,
  getImageOptions
} = svs.racing.common.imageOptions;
const {
  Image
} = svs.content.image_v2;
const {
  getCurrencyType,
  getTrackCondition,
  getRaceDirection
} = svs.racing.common.strings;
const {
  VODContext
} = svs.racing;
const Icon = svs.ui.ReactIcon;
const RacetrackInfo = props => {
  const {
    meeting,
    draws,
    direction,
    prizes,
    trackCondition,
    raceName,
    trackUuid,
    startTime,
    trackFormattedDate,
    totalPurse,
    raceNumber,
    currency,
    vodAssetId,
    vodAvailableUntil
  } = props.race;
  const race = props.race;
  const {
    setCurrentVOD
  } = useContext(VODContext);
  const [showFullInfo, setShowFullInfo] = useState(false);
  const imageOptions = trackUuid && trackFormattedDate && getImageOptions(trackUuid, trackFormattedDate, ImageTypes.Course);
  const currentFormattedDate = dateFns.format(new Date(startTime), 'yyMMdd', {
    locale: dateFns.locales.sv
  });
  const currencyToShow = currency ? getCurrencyType(currency) : '';
  const playVOD = function (assetId, currentFormattedDate, raceNumber) {
    let meeting = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    const vodObj = {
      assetId: assetId ? assetId : undefined,
      date: currentFormattedDate ? currentFormattedDate : '',
      track: meeting.track.name ? meeting.track.name : '',
      raceNumber: raceNumber ? raceNumber : ''
    };
    setCurrentVOD(vodObj);
  };
  const showVODButton = vodAssetId => {
    if (svs.core.detect.feature('ft-racing-vod') && dateFns.isBefore(new Date(race.startTime), new Date(2024, 0, 23))) {
      return false;
    }
    if (vodAssetId && vodAvailableUntil) {
      return new Date(vodAvailableUntil).getTime() > Date.now();
    }
    return false;
  };
  const renderProperty = (property, name, value) => {
    if (!value) {
      return undefined;
    }
    return React.createElement("div", null, React.createElement("span", {
      className: "racetrack-stretch-".concat(property, " item-header")
    }, "".concat(name, ": ")), React.createElement("span", {
      className: "racetrack-stretch-".concat(property, "-value")
    }, "".concat(value)));
  };
  return React.createElement("div", {
    className: "race-track-info"
  }, React.createElement("div", null, React.createElement("div", {
    className: "info-header"
  }, React.createElement("div", {
    className: "left-col"
  }, React.createElement(RacePickerItemLight, {
    meeting: meeting,
    raceSummary: _objectSpread(_objectSpread({}, race), {}, {
      draws
    })
  })), React.createElement("div", {
    className: "right-col"
  }, React.createElement("i", {
    className: "icon-default icon-300 ".concat(showFullInfo ? 'icon-menu-up' : 'icon-menu-down', " right pointer"),
    onClick: () => setShowFullInfo(!showFullInfo)
  }), showVODButton(vodAssetId) ? React.createElement("div", {
    className: "play-vod",
    onClick: () => playVOD(vodAssetId, currentFormattedDate, raceNumber, meeting)
  }, React.createElement(Icon, {
    color: "fc-grey-600",
    icon: "livestream",
    size: "200"
  })) : React.createElement("div", null)))), React.createElement("div", {
    className: "full-info ".concat(showFullInfo ? 'show-stuff' : '')
  }, React.createElement("div", {
    className: "left-part"
  }, raceName && React.createElement("div", {
    className: "item-racename item-section f-capitalize f-550"
  }, raceName), meeting.weather && React.createElement("div", {
    className: "item-weather item-section"
  }, "".concat(meeting.weather.forecast, " ").concat(meeting.weather.temperature, "\xB0C | Vind: ").concat(meeting.weather.wind, " km/h")), prizes && React.createElement("div", {
    className: "item-prizemoney item-section"
  }, React.createElement("div", {
    className: "item-header"
  }, "Prispengar:"), React.createElement("div", {
    className: "prizemoney-total"
  }, "Totalt: ".concat(totalPurse, " ").concat(currencyToShow)), React.createElement("div", {
    className: "prizemoney-body"
  }, Object.values(prizes).map(value => "".concat(value.placement, "a: ").concat(value.amount, " ").concat(currencyToShow)).join(' | '))), React.createElement("div", {
    className: "full-info-left-col"
  }, direction && renderProperty('direction', 'Löpriktning', getRaceDirection(direction)), trackCondition && renderProperty('condition', 'Banförhållanden', getTrackCondition(trackCondition)))), React.createElement("div", {
    className: "right-part"
  }, imageOptions && React.createElement("div", {
    className: "race-track-map f-center"
  }, React.createElement(Image, {
    image: imageOptions
  })))));
};
svs.racing_game.components.play.RacetrackInfo = RacetrackInfo;

 })(window);